import { Routes } from '../routing';

export const detailsReminderContent = {
    subTitle: 'Your details',
    description:
        'Make sure we have your latest details. This helps us give you the most accurate information based on your money needs.',
};

export const settingsMenuOptions = [
    {
        heading: '',
        options: [
            {
                label: 'Personal Information',
                location: Routes.UserDetails,
                href: null,
            },
        ],
    },
    {
        heading: '',
        options: [
            {
                label: 'Update Password',
                location: Routes.UserUpdatePassword,
                href: null,
            },
        ],
    },
];

export const termsOfUseConversation = [
    {
        question: 'The Terms and Conditions are soooo boring. Can we cut them out?',
        answer: 'No way. They’re very important.',
    },
    {
        question: 'What if we write them in rhyming couplets to make them more fun?',
        answer: '*blank stare*',
    },
    {
        question: 'What if we use lots of gifs and emojis to break it up?',
        answer: '*blank stares intensify*',
    },
    {
        question:
            'What if we have sections that explain the Terms and Conditions in Plain English?',
        answer: 'We’ll allow it.',
    },
];
